import React, { useEffect } from "react";
import useState from "react-usestateref";
import NeuroCareHeader from "../NeuroCareHeader";
import { Input, Layout } from "antd";
import { useAuth } from "../AuthProvider";
import { db } from "../firebase/firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";

const Mypage = () => {
  const { user } = useAuth();
  
  const [editOffice, setEditOffice] = useState(false);
  const [focusedInput, setFocusedInput] = useState(null);
  
  const [officeName, setOfficeName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [businessNum, setBusinessNum] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  const [editOfficeName, setEditOfficeName] = useState("");
  const [editBranchName, setEditBranchName] = useState("");
  const [editBusinessNum, setEditBusinessNum] = useState("");
  const [editPhoneNum, setEditPhoneNum] = useState("");
  const [editEmail, setEditEmail] = useState("");
  const [editAddress, setEditAddress] = useState("");

  // 확장검사 PIN
  const [pinInput, setPinInput] = useState("");
  const [extendedWeb, setExtendedWeb] = useState(false);

  useEffect(() => {
    const fetchFirestoreOfficeData = async () => {
      if (!user?.id) return;
      try {
        const infoDocRef = doc(db, "Accounts", user.id, "Info", "data");
        const docSnap = await getDoc(infoDocRef);

        if (docSnap.exists()) {
          const data = docSnap.data();

          if (data.officeName) {
            setOfficeName(data.officeName);
            setEditOfficeName(data.officeName);
          }
          if (data.branchName) {
            setBranchName(data.branchName);
            setEditBranchName(data.branchName);
          }
          if (data.phoneNum) {
            setPhoneNum(data.phoneNum);
            setEditPhoneNum(data.phoneNum);
          }
          if (data.email) {
            setEmail(data.email);
            setEditEmail(data.email);
          }
          if (data.address) {
            setAddress(data.address);
            setEditAddress(data.address);
          }
          
          const bNum = data.businessNum || user?.comNum || "";
          setBusinessNum(bNum);
          setEditBusinessNum(bNum);

          setExtendedWeb(data.extendedWeb === true);

        } else {
          console.warn("Info 문서가 존재하지 않습니다.");
        }
      } catch (error) {
        console.error("Firestore 데이터 가져오기 실패:", error);
      }
    };

    fetchFirestoreOfficeData();
  }, [user]);

  const confirmBtnClicked = async () => {
    const infoRef = doc(db, "Accounts", user.id, "Info", "data");

    // 전화번호는 숫자만
    const cleanPhoneNum = editPhoneNum.replace(/[^0-9]/g, "");

    const baseData = {
      officeName: editOfficeName,
      branchName: editBranchName,
      businessNum: editBusinessNum,
      phoneNum: cleanPhoneNum,
      email: editEmail,
      address: editAddress,
    };

    try {
      await setDoc(infoRef, baseData, { merge: true });

      setOfficeName(editOfficeName);
      setBranchName(editBranchName);
      setBusinessNum(editBusinessNum);
      setPhoneNum(cleanPhoneNum);
      setEditPhoneNum(cleanPhoneNum);
      setEmail(editEmail);
      setAddress(editAddress);
      
      setEditOffice(false);
      alert("등록/수정 되었습니다.");
    } catch (error) {
      console.error("Firestore update failed:", error);
      alert("등록 실패");
    }
  };

  // 확장검사 PIN 확인
  const handlePinRegister = async () => {
    const code = pinInput.trim();
    if (!code) {
      alert("PIN 번호를 입력해주세요.");
      return;
    }
    try {
      const pinSnap = await getDoc(doc(db, "CustomTestCodes", code));
      if (!pinSnap.exists() || pinSnap.data().usedBy !== user.id) {
        alert("유효하지 않은 PIN입니다.");
        return;
      }
      await setDoc(
        doc(db, "Accounts", user.id, "Info", "data"),
        { extendedWeb: true },
        { merge: true }
      );
      setExtendedWeb(true);
      setPinInput("");
      alert("PIN이 등록되었습니다.");
    } catch (error) {
      console.error("PIN 확인 실패:", error);
      alert("PIN 확인 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const handlePinDeactivate = async () => {
    if (!window.confirm("확장검사를 비활성화하시겠습니까?")) return;
    try {
      await setDoc(
        doc(db, "Accounts", user.id, "Info", "data"),
        { extendedWeb: false },
        { merge: true }
      );
      setExtendedWeb(false);
      setPinInput("");
      alert("확장검사가 비활성화되었습니다.");
    } catch (error) {
      console.error("확장검사 비활성화 실패:", error);
      alert("비활성화 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const handleCancel = () => {
    setEditOfficeName(officeName);
    setEditBranchName(branchName);
    setEditBusinessNum(businessNum); 
    setEditPhoneNum(phoneNum);
    setEditEmail(email);
    setEditAddress(address);
    setEditOffice(false);
    setFocusedInput(null);
  };

  const getInputStyle = (inputId) => ({
    padding: "10px 12px",
    borderRadius: "6px",
    fontSize: "15px",
    border: `1px solid ${focusedInput === inputId ? "#2C6AFF" : "#C4DBFB"}`,
    backgroundColor: focusedInput === inputId ? "#FFFFFF" : "#F0F6FE",
    outline: "none",
    boxShadow: "none",
    transition: "all 0.2s ease-in-out",
    color: "#0f172a",
  });

  const styles = {
    pageWrapper: {
      display: "flex",
      justifyContent: "center", 
      padding: "50px 20px",    
      minHeight: "calc(100vh - 64px)", 
      backgroundColor: "#fafafa",
      fontFamily: "Pretendard, sans-serif"
    },
    contentContainer: {
      width: "100%",
      maxWidth: "900px", 
    },
    titleWrapper: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
    },
    titleBar: {
      width: "4px",
      height: "18px",
      backgroundColor: "#3b82f6",
      marginRight: "10px",
      borderRadius: "2px"
    },
    titleText: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#1e293b",
      margin: 0
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      border: "1px solid #e2e8f0",
      overflow: "hidden", 
      textAlign: "left", 
    },
    rowGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr", 
      borderBottom: "1px solid #e2e8f0",
    },
    rowFull: {
      borderBottom: "1px solid #e2e8f0",
    },
    cell: {
      padding: "24px",
    },
    cellBorderRight: {
      borderRight: "1px solid #e2e8f0",
    },
    label: {
      fontSize: "13px",
      color: "#64748b",
      marginBottom: "10px",
      fontWeight: "500"
    },
    valueText: {
      fontSize: "15px",
      color: "#0f172a",
      fontWeight: "500",
      minHeight: "22px",
      display: "flex",
      alignItems: "center" 
    },
    footer: {
      padding: "20px 24px",
      display: "flex",
      justifyContent: "flex-end", 
      gap: "10px",
      backgroundColor: "#ffffff"
    },
    primaryBtn: {
      backgroundColor: "#2C6AFF",
      color: "white",
      border: "none",
      borderRadius: "6px",
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
    },
    defaultBtn: {
      backgroundColor: "#ffffff",
      color: "#64748b",
      border: "1px solid #cbd5e1",
      borderRadius: "6px",
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
    }
  };

  return (
    <Layout style={{ background: "#ffffff", minHeight: "100vh" }}>
      <NeuroCareHeader selectedMenu={"마이페이지"} />
      
      <div style={styles.pageWrapper}>
        <div style={styles.contentContainer}>
          
          <div style={styles.titleWrapper}>
            <div style={styles.titleBar}></div>
            <h2 style={styles.titleText}>사업장 정보</h2>
          </div>

          <div style={styles.card}>
            
            <div style={styles.rowGrid}>
              <div style={{...styles.cell, ...styles.cellBorderRight}}>
                <div style={styles.label}>사업장 명</div>
                {editOffice ? (
                  <Input 
                    style={getInputStyle("officeName")} 
                    value={editOfficeName} 
                    onChange={(e) => setEditOfficeName(e.target.value)}
                    onFocus={() => setFocusedInput("officeName")}
                    onBlur={() => setFocusedInput(null)} 
                  />
                ) : (
                  <div style={styles.valueText}>{officeName || <span style={{color: '#cbd5e1'}}>미입력</span>}</div>
                )}
              </div>
              <div style={styles.cell}>
                <div style={styles.label}>지점</div>
                {editOffice ? (
                  <Input 
                    style={getInputStyle("branchName")} 
                    value={editBranchName} 
                    onChange={(e) => setEditBranchName(e.target.value)}
                    onFocus={() => setFocusedInput("branchName")}
                    onBlur={() => setFocusedInput(null)} 
                  />
                ) : (
                  <div style={styles.valueText}>{branchName || <span style={{color: '#cbd5e1'}}>미입력</span>}</div>
                )}
              </div>
            </div>

            <div style={styles.rowGrid}>
              <div style={{...styles.cell, ...styles.cellBorderRight}}>
                <div style={styles.label}>사업자 번호</div>
                {editOffice ? (
                  <Input 
                    style={getInputStyle("businessNum")} 
                    value={editBusinessNum} 
                    onChange={(e) => setEditBusinessNum(e.target.value)}
                    onFocus={() => setFocusedInput("businessNum")}
                    onBlur={() => setFocusedInput(null)}
                    placeholder="사업자 번호를 입력하세요." 
                  />
                ) : (
                  <div style={styles.valueText}>{businessNum || <span style={{color: '#cbd5e1'}}>미입력</span>}</div>
                )}
              </div>
              <div style={styles.cell}>
                <div style={styles.label}>전화번호</div>
                {editOffice ? (
                  <Input 
                    style={getInputStyle("phoneNum")} 
                    value={editPhoneNum} 
                    onChange={(e) => setEditPhoneNum(e.target.value)}
                    onFocus={() => setFocusedInput("phoneNum")}
                    onBlur={() => setFocusedInput(null)} 
                  />
                ) : (
                  <div style={styles.valueText}>{phoneNum || <span style={{color: '#cbd5e1'}}>미입력</span>}</div>
                )}
              </div>
            </div>

            <div style={styles.rowFull}>
              <div style={styles.cell}>
                <div style={styles.label}>주소</div>
                {editOffice ? (
                  <Input 
                    style={getInputStyle("address")} 
                    value={editAddress} 
                    onChange={(e) => setEditAddress(e.target.value)}
                    onFocus={() => setFocusedInput("address")}
                    onBlur={() => setFocusedInput(null)} 
                  />
                ) : (
                  <div style={styles.valueText}>{address || <span style={{color: '#cbd5e1'}}>미입력</span>}</div>
                )}
              </div>
            </div>

            <div style={styles.rowFull}>
              <div style={styles.cell}>
                <div style={styles.label}>이메일</div>
                {editOffice ? (
                  <Input 
                    style={getInputStyle("email")} 
                    value={editEmail} 
                    onChange={(e) => setEditEmail(e.target.value)}
                    onFocus={() => setFocusedInput("email")}
                    onBlur={() => setFocusedInput(null)} 
                  />
                ) : (
                  <div style={styles.valueText}>{email || <span style={{color: '#cbd5e1'}}>미입력</span>}</div>
                )}
              </div>
            </div>

            <div style={styles.footer}>
              {!editOffice ? (
                <button style={styles.primaryBtn} onClick={() => setEditOffice(true)}>
                  수정
                </button>
              ) : (
                <>
                  <button style={styles.defaultBtn} onClick={handleCancel}>
                    취소
                  </button>
                  <button style={styles.primaryBtn} onClick={confirmBtnClicked}>
                    저장
                  </button>
                </>
              )}
            </div>

          </div>

          <div style={{ ...styles.titleWrapper, marginTop: "32px" }}>
            <div style={styles.titleBar}></div>
            <h2 style={styles.titleText}>확장검사 PIN</h2>
          </div>

          <div style={styles.card}>
            <div style={styles.cell}>
              {extendedWeb ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "#16a34a",
                      background: "#eafaf0",
                      padding: "3px 10px",
                      borderRadius: "10px",
                    }}
                  >
                    확장검사 활성화됨
                  </span>
                  <span style={{ fontSize: "13px", color: "#64748b" }}>
                    검사데이터에서 확장검사 결과가 표시됩니다.
                  </span>
                  <button
                    style={{ ...styles.defaultBtn, marginLeft: "auto" }}
                    onClick={handlePinDeactivate}
                  >
                    비활성화
                  </button>
                </div>
              ) : (
                <>
                  <div style={styles.label}>PIN 번호</div>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Input
                      style={{ ...getInputStyle("extendedPin"), flex: 1 }}
                      value={pinInput}
                      onChange={(e) => setPinInput(e.target.value)}
                      onFocus={() => setFocusedInput("extendedPin")}
                      onBlur={() => setFocusedInput(null)}
                      onPressEnter={handlePinRegister}
                      placeholder="발급받은 PIN 번호를 입력하세요."
                    />
                    <button
                      style={styles.primaryBtn}
                      onClick={handlePinRegister}
                    >
                      등록
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Mypage;